import { EcapReportGroupEnum, ReportTypeEnum, MitigationSouresType, RECOVERY_STATUS, ReportStatesEnum, RISK_LEVELS, RISK_TYPES, STATUS_DOCUMENTATIONS } from "../constants/constants";
import { AppraisalModel } from "../models/appraisal.model";
import { SectionsModel, SectionStatusModel } from "../models/common/base-form.model";
import { ControlFailureModel } from "../models/control-failure.model";
import { FormSectionModel } from "../models/form-section.model";
import { ScenarioMitigationModel } from "../models/scenario-mitigation.model";
import { ScenarioModel } from "../models/scenario.model";
import { StatusDomModel } from "../models/status-dom.model";
import { DATE_UTIL } from "./dateUtils";
import i18n from "./i18n";


/********************************************* Control Failure *************************************************/

const convertEditFormControlFailureData = (data: ControlFailureModel) => {
    data.approval_date_picker = DATE_UTIL.convertServerToDatePicker(data.approval_date);
    data.actual_completion_date_picker = DATE_UTIL.convertServerToDatePicker(data.actual_completion_date);
    data.target_completion_date_picker = DATE_UTIL.convertServerToDatePicker(data.target_completion_date);
    data.recording_date_picker = DATE_UTIL.convertServerToDatePicker(data.recording_date);
    data.occurrence_date_picker = DATE_UTIL.convertServerToDatePicker(data.occurrence_date);
    data.recognition_date_picker = DATE_UTIL.convertServerToDatePicker(data.recognition_date);
    data.other_recovery_date_picker = DATE_UTIL.convertServerToDatePicker(data.other_recovery_date);
    data.insurance_recovery_date_picker = DATE_UTIL.convertServerToDatePicker(data.insurance_recovery_date);
    data.category_id = data.category?.id;
    data.category_level_2_id = data.category_level_2?.id;
    data.category_level_3_id = data.category_level_3?.id;
    data.reporter_division_id = data.reporter_division?.id;
    data.reporter_business_unit_id = data.reporter_business_unit?.id;
    data.type_of_event_id = data.type_of_event?.id;
    data.direct_loss_type_id = data.direct_loss_type?.id;
    if (!data.loss_event_experiences || !data.loss_event_experiences.length) {
        data.loss_event_experiences = [{}]
    }
    data.failed_control_area_id = data.failed_control_area?.id;
    data.caused_division_id = data.caused_division?.id;
    data.caused_business_unit_id = data.caused_business_unit?.id;
    data.caused_svp_id = data.caused_svp?.id;

    return data;
}


const prepareControlFailureDataForSubmit = (data: ControlFailureModel) => {

    if (data.approval_date_picker !== undefined) {
        data.approval_date = DATE_UTIL.convertDatePickerToServerFormat(data.approval_date_picker);
    }

    if (data.actual_completion_date_picker !== undefined) {
        data.actual_completion_date = DATE_UTIL.convertDatePickerToServerFormat(data.actual_completion_date_picker);
    }

    if (data.target_completion_date_picker !== undefined) {
        data.target_completion_date = DATE_UTIL.convertDatePickerToServerFormat(data.target_completion_date_picker);
    }

    if (data.recording_date_picker !== undefined) {
        data.recording_date = DATE_UTIL.convertDatePickerToServerFormat(data.recording_date_picker);
    }

    if (data.occurrence_date_picker !== undefined) {
        data.occurrence_date = DATE_UTIL.convertDatePickerToServerFormat(data.occurrence_date_picker);
    }

    if (data.recognition_date_picker !== undefined) {
        data.recognition_date = DATE_UTIL.convertDatePickerToServerFormat(data.recognition_date_picker);
    }

    if (data.other_recovery_date_picker !== undefined) {
        data.other_recovery_date = DATE_UTIL.convertDatePickerToServerFormat(data.other_recovery_date_picker);
    }

    if (data.insurance_recovery_date_picker !== undefined) {
        data.insurance_recovery_date = DATE_UTIL.convertDatePickerToServerFormat(data.insurance_recovery_date_picker);
    }

    if (data.loss_event_experiences && data.loss_event_experiences.length) {
        data.loss_event_experiences.forEach((item) => {
            item = mapNullDataForObject(item);
        })
    }

    return mapNullDataForObject(data);
}

/********************************** End Control Failure ************************************************/

/********************************** Scenario ***********************************************************/
const convertEditScenatioDesignForm = (data: ScenarioModel) => {
    if (data.category && data.category?.id) {
        data.category_id = data.category?.id;
    }

    if (data.category_level_2 && data.category_level_2?.id) {
        data.category_level_2_id = data.category_level_2?.id;
    }

    if (data.category_level_3 && data.category_level_3?.id) {
        data.category_level_3_id = data.category_level_3?.id;
    }

    if (data.direct_loss_type && data.direct_loss_type?.id) {
        data.direct_loss_type_id = data.direct_loss_type?.id;
    }

    if (data.designer_division && data.designer_division?.id) {
        data.designer_division_id = data.designer_division?.id;
    }

    if (data.designer_business_unit && data.designer_business_unit?.id) {
        data.designer_business_unit_id = data.designer_business_unit?.id;
    }

    if (data.likely_failed_control_area && data.likely_failed_control_area?.id) {
        data.likely_failed_control_area_id = data.likely_failed_control_area?.id;
    }

    if (!data.scenario_event_experiences || !data.scenario_event_experiences.length) {
        data.scenario_event_experiences = [{}]
    }

    if (!data.planing_cycle_month) {
        data.planing_cycle_month = new Date().getMonth();
    }

    if (!data.planing_cycle_year) {
        data.planing_cycle_year = new Date().getFullYear();
    }

    if (!data.planing_cycle_end_date_month) {
        data.planing_cycle_end_date_month = new Date().getMonth();
    }

    if (!data.planing_cycle_end_date_year) {
        data.planing_cycle_end_date_year = new Date().getFullYear();
    }

    return data;
}

const prepareScenatioDesignFormForSubmit = (data: ScenarioModel) => {
    if (data.scenario_event_experiences && data.scenario_event_experiences.length) {
        data.scenario_event_experiences.forEach((item) => {
            item = mapNullDataForObject(item);
        })
    }
    return mapNullDataForObject(data);
}


/********************************** End Scenario ***********************************************************/

/********************************** Mitigation ************************************************************/
const convertDataMitigationForm = (data: ScenarioMitigationModel) => {

    data.internal = data.sources?.filter(p => p.type === MitigationSouresType.Internal);
    if (!data.internal || !data.internal.length) {
        data.internal = [{
        }]
    }
    data.external = data.sources?.filter(p => p.type === MitigationSouresType.External);
    if (!data.external || !data.external.length) {
        data.external = [{
        }]
    }
    data.review_dates?.map(item => {
        item.review_date_picker = DATE_UTIL.convertServerToDatePicker(item.review_date);
        return item;
    });

    if (!data.review_dates || !data.review_dates.length) {
        data.review_dates = [{
        }]
    }
    return data;
}

const prepareMitigationFormForSubmit = (data: ScenarioMitigationModel) => {
    if (data.internal && data.internal.length) {
        if (!data.sources) {
            data.sources = [];
        }
        data.internal.forEach((item) => {
            if (item) {
                item = mapNullDataForObject(item);
                data.sources?.push({ ...item, type: MitigationSouresType.Internal })
            }
        })
    }

    if (data.external && data.external.length) {
        if (!data.sources) {
            data.sources = [];
        }
        data.external.forEach((item) => {
            if (item) {
                item = mapNullDataForObject(item);
                data.sources?.push({ ...item, type: MitigationSouresType.External })
            }
        })
    }

    if (data.review_dates && data.review_dates.length) {
        data.review_dates.forEach((item) => {
            if (item) {
                item.review_date = DATE_UTIL.convertDatePickerToServerFormat(item.review_date_picker);
            } else {
                item = {}
            }
        })
    }

    return mapNullDataForObject(data);
}
/********************************** End Mitigation ***********************************************************/

/********************************** Appraisal ***********************************************************/
const convertAppraisalForm = (data: AppraisalModel) => {
    if (!data.purpose_fulfillment || !data.purpose_fulfillment.length) {
        data.purpose_fulfillment = [{}]
    }

    if (!data.breakdown_of_funding_and_benefits || !data.breakdown_of_funding_and_benefits.length) {
        data.breakdown_of_funding_and_benefits = [{
            details: [{
            }]
        }]
    }

    return data;
}

const prepareAppraisalFormForSubmit = (data: AppraisalModel) => {
    if (data.breakdown_of_funding_and_benefits && data.breakdown_of_funding_and_benefits.length) {
        data.breakdown_of_funding_and_benefits.forEach((item) => {
            if (item) {
                item = mapNullDataForObject(item);
            }
        })
    }

    if (data.purpose_fulfillment && data.purpose_fulfillment.length) {
        data.purpose_fulfillment.forEach((item) => {
            if (item) {
                item = mapNullDataForObject(item);
            }
        })
    }

    return mapNullDataForObject(data);
}

/********************************** End Appraisal ***********************************************************/

const getRiskLevelName = (value: string | undefined) => {
    if (!value) {
        return value;
    }

    return RISK_LEVELS.find(p => p.value === value)?.name;
}

const getStatusDocumentationName = (value: string | undefined) => {
    if (!value) {
        return value;
    }

    return STATUS_DOCUMENTATIONS.find(p => p.value === value)?.name;
}

const getRecoveryStatusName = (value: string | undefined) => {
    if (!value) {
        return value;
    }

    return RECOVERY_STATUS.find(p => p.value === value)?.name;
}

const getRiskTypeName = (value: string | undefined) => {
    if (!value) {
        return value;
    }

    return RISK_TYPES.find(p => p.value === value)?.name;
}

const cleanObject = (obj: any) => {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
}

const mapNullDataForObject = (obj: any) => {
    for (var propName in obj) {
        if (obj[propName] === undefined) {
            obj[propName] = null;
        }
    }
    return obj
}

const setSectionIsCompleted = (section_statuses: SectionStatusModel[] | undefined, sections: FormSectionModel[]) => {
    if (section_statuses && section_statuses.length) {
        sections.forEach((item, index) => {
            const sc = section_statuses.find(x => x.section_id === item.id);
            if (sc) {
                item.is_completed = sc.is_completed;
            }
        })
    }
}

const getAllRequiredFields = (sections: SectionsModel[] | undefined) => {
    let rqFields: string[] = [];
    sections?.forEach(item => {
        if (item.required_fields) {
            rqFields = [...rqFields, ...item.required_fields];
        }
    })

    return rqFields;
}

const getLossStatesDOM = (status: string | undefined): StatusDomModel => {
    switch (status) {
        case ReportStatesEnum.New:
            return {
                color: "#EF753F",
                bgColor: "#FFFAF8",
                text: i18n.t("Status.new")
            }
        case ReportStatesEnum.Draft:
            return {
                color: "#AFAFAF",
                bgColor: "#F5F5F5",
                text: i18n.t("Status.draft")
            }
        case ReportStatesEnum.Submitting:
            return {
                color: "#D5D5D5",
                bgColor: "#F5F5F5",
                text: i18n.t("Status.submitting")
            }
        case ReportStatesEnum.Submitted:
            return {
                color: "#EF753F",
                bgColor: "#FFFAF8",
                text: i18n.t("Status.pending")
            }
        case ReportStatesEnum.Approved:
            return {
                color: "#69BA6D",
                bgColor: "#E9F5EA",
                text: i18n.t("Status.approved")
            }
        // case ReportStatesEnum.Rejected:
        //     return {
        //         color: "#EE4F39",
        //         bgColor: "#FFE4E0",
        //         text: i18n.t("Status.referred")
        //     }
        case ReportStatesEnum.Rejected:
            return {
                color: "#EE4F39",
                bgColor: "#FFE4E0",
                text: i18n.t("Status.returned")
            }
        default:
            return {}
    }
}

const planingCycleYears = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const years = [];
    for (let index = currentYear; index < currentYear + 10; index++) {
        years.push(index);
    }
    return years;
}

const checkCanEditByState = (state: ReportStatesEnum | undefined) => {
    return (!state || state === ReportStatesEnum.Draft
        || state === ReportStatesEnum.New
        || state === ReportStatesEnum.Submitting);
}

const CheckShowReviewByState = (state: ReportStatesEnum | undefined) => {
    return state === ReportStatesEnum.Submitted ||
        state === ReportStatesEnum.Approved ||
        state === ReportStatesEnum.Rejected;
}

const bytesToSize = (bytes: number) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    var i = (Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
}

const removeFileExtention = (fileName: string) => {
    return fileName.split('.').slice(0, -1).join('.');
}

const getECapReportTypeDisplay = (type?: ReportTypeEnum | string) => {
    switch (type) {
        case ReportTypeEnum.CreditRisk:
            return i18n.t("EcapModule.lbCreditRisk");
        case ReportTypeEnum.MarketRisk:
            return i18n.t("EcapModule.lbMarketRisk");
        case ReportTypeEnum.OperationalRisk:
            return i18n.t("EcapModule.lbOperationalRisk");
        case ReportTypeEnum.BusinessRisk:
            return i18n.t("EcapModule.lbBusinessRisk");
        case ReportTypeEnum.ConcentrationRisk:
            return i18n.t("EcapModule.lbConcentrationRisk");
        case ReportTypeEnum.InterestRateRisk:
            return i18n.t("EcapModule.lbInterestRateRisk");
        case ReportTypeEnum.Ramp:
            return i18n.t("EcapModule.lbRapm");
        default:
            return "";
    }
}

const getECapReportGroupDisplay = (type?: EcapReportGroupEnum) => {
    switch (type) {
        case EcapReportGroupEnum.Pillar1:
            return i18n.t("EcapModule.Pillar1Tile");
        case EcapReportGroupEnum.Pillar2:
            return i18n.t("EcapModule.Pillar2Tile");
        default:
            return "";
    }
}


const randomColor = function (key: string = "A") {
    var hash = 0;
    if (key.length === 0) return hash.toString();
    for (let i = 0; i < key.length; i++) {
        hash = key.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    var color = '#';
    for (let i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 255;
        color += ('EE' + value.toString(16)).substr(-2);
    }
    return color;

}

const removeSpaces = (str: string | undefined) => {
    if (!str) {
        return "";
    }
    return str = str.replace(/\s/g, '');
}

const UTIL = {
    convertEditFormControlFailureData,
    prepareControlFailureDataForSubmit,
    convertEditScenatioDesignForm,
    cleanObject,
    getRiskLevelName,
    getStatusDocumentationName,
    getRecoveryStatusName,
    getRiskTypeName,
    setSectionIsCompleted,
    getLossStatesDOM,
    planingCycleYears,
    getAllRequiredFields,
    convertDataMitigationForm,
    prepareScenatioDesignFormForSubmit,
    prepareMitigationFormForSubmit,
    convertAppraisalForm,
    prepareAppraisalFormForSubmit,
    checkCanEditByState,
    CheckShowReviewByState,
    bytesToSize,
    removeFileExtention,
    getECapReportTypeDisplay,
    getECapReportGroupDisplay,
    randomColor,
    removeSpaces
}

export default UTIL;